import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import registerProperties from "./global/register-properties";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// import "element-plus/lib/theme-chalk/base.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { initData } from "./store";
import { permDirective } from "@/directives/permission";
// 测试代码的执行
// import "./service/main/system/system";
const app = createApp(App);
app.directive("perm", permDirective);
app.use(store);
app.use(router);
app.use(registerProperties);
app.use(ElementPlus, { locale: zhCn });
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
initData();
app.mount("#app");
